import { useMemo } from 'react';

import { FileStatus, FileType } from 'services/file.service';
import { useAppSelector } from 'store/store-hooks';
import { useMousePositionContext } from 'components/app/_mediator/app-cursor-position.provider';

import { FcStatus } from 'components/app/app-components/fc-status/fc-status';
import styles from '../_sections.module.scss';

export const ThumbPrev = () => {
  const { hoveredFile, hoveredFc } = useAppSelector((state) => state.projects);
  const { finalcuts } = useAppSelector((state) => state.app__data);
  const files = useAppSelector((state) => state.app__files.files);
  const posters = useAppSelector((state) => state.app__files.posters);
  const { mousePosition } = useMousePositionContext();

  const fileContent = useMemo(() => {
    if (!hoveredFile) return null;
    const file = files[hoveredFile];
    if (!file) return null;
    if (file.status === FileStatus.Error) return 'Broken File';
    if (posters[file.id]) return <img src={posters[file.id]!} crossOrigin="anonymous" />;
    return FileType[file.fileType];
  }, [hoveredFile]);

  const fcContent = useMemo(() => {
    if (!hoveredFc) return null;
    const fc = finalcuts.find((fc) => fc.id === hoveredFc);
    if (!fc) return null;
    if (fc.thumbnailUrl) return <img src={fc.thumbnailUrl} crossOrigin="anonymous" />;
    return <FcStatus fc={fc} />;
  }, [hoveredFc, finalcuts]);

  if (!fileContent && !fcContent) return null;

  return (
    <div className={styles.ThumbPrev} style={{ left: mousePosition.x, top: mousePosition.y }}>
      {fileContent}
      {fcContent}
    </div>
  );
};
